import gql from 'graphql-tag';

export default gql`
  query user($communityId: String = "", $auth0User: String = "") {
    user(input: { communityId: $communityId, auth0User: $auth0User }) {
      atid
      auth0User
      communityId
      displayName
      roles
      url
      email
      firstName
      lastName
      zipCode
      originatingSite
      city
      jobTitle
      image
      urls
      bio
      status
      imageId
    }
  }
`;
